import config from 'react-global-configuration';

import type { Thunk } from '../../../types';

export const SET_OPENED_WITH_NOTIFICATION_ID = 'SET_OPENED_WITH_NOTIFICATION_ID';
export const setOpenedWithNotificationId = (notificationId: number) => ({
  type: SET_OPENED_WITH_NOTIFICATION_ID,
  notificationId,
});

export const CLEAR_OPENED_WITH_NOTIFICATION_ID = 'CLEAR_OPENED_WITH_NOTIFICATION_ID';
export const clearOpenedWithNotificationId = () => ({ type: CLEAR_OPENED_WITH_NOTIFICATION_ID });

export const logNotificationActionIfActive =
  (actionType: string): Thunk => (dispatch, getState) => {
    const notificationId = getState().getIn(['notification', 'openedWithNotificationId']);
    if (!notificationId) return;

    dispatch(clearOpenedWithNotificationId());

    const API_URL: string = config.get('API_URL');
    const language: string = getState().getIn(['ui', 'language']);
    const MULTILINGUAL: boolean = config.get('MULTILINGUAL', true);
    const PATH = MULTILINGUAL ? `${API_URL}/${language}` : API_URL;

    fetch(`${PATH}/rest/session/token`, { credentials: 'include' })
      .then((r) => r.text())
      .then((csrfToken) => fetch(`${PATH}/api/notification-action?_format=json`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': csrfToken,
        },
        body: JSON.stringify({ notification_id: notificationId, action_type: actionType }),
      }))
      .catch(() => {});
  };

export const logNotificationOpened = (notificationId: number): Thunk => (dispatch, getState) => {
  const API_URL: string = config.get('API_URL');
  const language: string = getState().getIn(['ui', 'language']);
  const MULTILINGUAL: boolean = config.get('MULTILINGUAL', true);
  const PATH = MULTILINGUAL ? `${API_URL}/${language}` : API_URL;

  return fetch(`${PATH}/rest/session/token`, { credentials: 'include' })
    .then((r) => r.text())
    .then((csrfToken) => fetch(`${PATH}/api/notification-opened?_format=json`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrfToken,
      },
      body: JSON.stringify({ notification_id: notificationId }),
    }))
    .catch(() => {});
};
